(function () {
  const CART_MUTATION_PATTERN =
    /\/cart\/(add|change|update|clear)(?:\.js)?(?:\?|$)/;

  let updateTimer = null;
  let updateInProgress = false;
  let updateRequestedAgain = false;

  async function getCartSummary() {
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {
        credentials: 'same-origin',
        cache: 'no-store'
      });

      if (!response.ok) {
        throw new Error(`Cart request failed: ${response.status}`);
      }

      const cart = await response.json();
      if (!Array.isArray(cart.items)) throw new Error('Invalid cart response');
      return {
        totalCents: Number(cart.total_price || 0),
        productIds: cart.items.filter(item => item.quantity > 0).map(item => Number(item.product_id))
      };
    } catch (error) {
      console.error('Free shipping progress:', error);
      return null;
    }
  }

  function formatMoney(cents) {
    try {
      const currency =
        window.Shopify?.currency?.active ||
        window.Shopify?.currency?.iso_code ||
        'RON';

      const locale = document.documentElement.lang || 'ro-RO';

      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency
      }).format(cents / 100);
    } catch (error) {
      return `${(cents / 100).toFixed(2)} RON`;
    }
  }

  function getProgressBars() {
    return Array.from(
      document.querySelectorAll('.fsp[data-threshold]')
    );
  }

  function renderProgressBar(element, cart) {
    const excludedProductId = Number(element.dataset.fspExcludedProductId || 0);
    const excluded = excludedProductId > 0 && cart.productIds.includes(excludedProductId);
    element.hidden = excluded;
    if (excluded) {
      element.style.setProperty('display', 'none', 'important');
      return;
    }
    element.style.removeProperty('display');
    const totalCents = cart.totalCents;
    const threshold = Number(element.dataset.threshold || 0);

    const textElement = element.querySelector('[data-fsp-text]');
    const fillElement = element.querySelector('[data-fsp-fill]');

    if (!threshold || !textElement || !fillElement) return;

    const remaining = Math.max(threshold - totalCents, 0);
    const percentage = Math.min(
      Math.max((totalCents / threshold) * 100, 0),
      100
    );

    fillElement.style.width = `${percentage}%`;

    if (remaining === 0) {
      textElement.textContent = '✅ Ai transport gratuit!';
    } else {
      textElement.innerHTML =
        `Mai adaugă <strong>${formatMoney(remaining)}</strong> ` +
        'pentru transport gratuit.';
    }
  }

  async function updateProgressBars() {
    if (updateInProgress) {
      updateRequestedAgain = true;
      return;
    }

    updateInProgress = true;

    try {
      const cart = await getCartSummary();

      if (cart === null) return;

      getProgressBars().forEach((element) => {
        renderProgressBar(element, cart);
      });
    } finally {
      updateInProgress = false;

      if (updateRequestedAgain) {
        updateRequestedAgain = false;
        scheduleUpdate(150);
      }
    }
  }

  function scheduleUpdate(delay = 250) {
    window.clearTimeout(updateTimer);

    updateTimer = window.setTimeout(() => {
      updateProgressBars();
    }, delay);
  }

  function isCartMutationRequest(input) {
    try {
      const rawUrl =
        typeof input === 'string'
          ? input
          : input instanceof Request
            ? input.url
            : input?.url;

      if (!rawUrl) return false;

      const url = new URL(rawUrl, window.location.origin);

      return CART_MUTATION_PATTERN.test(url.pathname);
    } catch (error) {
      return false;
    }
  }

  function bindCartEvents() {
    window.addEventListener('pageshow', event => {
      if (event.persisted) scheduleUpdate(0);
    });
    document.addEventListener('change', (event) => {
      const target = event.target;

      if (
        target instanceof Element &&
        target.matches(
          'input[name="updates[]"], .quantity__input'
        )
      ) {
        scheduleUpdate(500);
      }
    });

    document.addEventListener('click', (event) => {
      const target =
        event.target instanceof Element ? event.target : null;

      const cartControl = target?.closest(
        [
          'cart-remove-button',
          '.quantity__button',
          'a[href*="/cart/change"]',
          'button[name="update"]'
        ].join(', ')
      );

      if (cartControl) {
        scheduleUpdate(500);
      }
    });

    /*
     * Ascultăm numai requesturile care MODIFICĂ coșul.
     * /cart.js este exclus intenționat pentru a evita bucla infinită.
     */
    if (!window.__FSP_FETCH_PATCHED__) {
      window.__FSP_FETCH_PATCHED__ = true;

      const originalFetch = window.fetch;

      window.fetch = function (...args) {
        const modifiesCart = isCartMutationRequest(args[0]);
        const request = originalFetch.apply(this, args);

        if (modifiesCart) {
          request.finally(() => {
            /*
             * Integrarea locker poate reranda coșul puțin mai târziu.
             * Facem două citiri controlate, nu polling continuu.
             */
            scheduleUpdate(150);
            window.setTimeout(() => scheduleUpdate(0), 600);
          });
        }

        return request;
      };
    }
  }

  function boot() {
    if (window.__FSP_INITIALIZED__) {
      updateProgressBars();
      return;
    }

    window.__FSP_INITIALIZED__ = true;

    bindCartEvents();
    updateProgressBars();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, {
      once: true
    });
  } else {
    boot();
  }
})();